<template>
  <div>
    <el-row :gutter="20">
      <el-col
        :span="lefeSpan"
        style="
          box-shadow: -2px -7px 7px 5px #ccc;
          padding-right: 0px;
          height: 100vh;
          overflow: auto;
          position: sticky;
          top: 0;
        "
      >
        <div class="left">
          <el-button
            type="success"
            plain
            size="mini"
            style="margin-right: 15px; margin-top: 4px; float: left"
            @click="backIndex"
          >
            <i class="el-icon-s-home" style="font-size: 16px"></i>
          </el-button>
          <img
            src="../images/logo (2).png"
            width="80px"
            style="vertical-align: middle; margin-top: 9px"
            class="iphoneS"
          />
          <el-tooltip
            class="item"
            effect="dark"
            :content="foldM ? '收缩目录' : '展开目录'"
            placement="top"
          >
            <span
              style="
                margin-right: 15px;
                font-weight: bold;
                font-size: 18px;
                float: right;
                margin-top: 5px;
                font-size: 23px;
                color: #002eb6;
                cursor: pointer;
              "
              @click="foldFuM"
            >
              <i :class="foldM ? 'el-icon-s-fold' : 'el-icon-s-unfold'"></i>
            </span>
          </el-tooltip>
        </div>

        <div style="height: 90vh; overflow: auto">
          <!-- <el-tree
            :data="data"
            :props="defaultProps"
            accordion
            @node-click="handleNodeClick"
            icon="el-icon-check"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span style="position: relative">
                <i
                  :class="data.icon"
                  style="
                    color: #0bf96e;
                    position: absolute;
                    left: -27px;
                    top: 4px;
                  "
                ></i
                >{{ node.label }}
              </span>
            </span>

          </el-tree> -->
          <el-tree
            :props="props"
            :load="loadNode"
            lazy
            @node-click="handleNodeClick"
            accordion
            icon="el-icon-check"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span style="position: relative">
                <i
                  :class="node.data.icon"
                  style="
                    color: #0bf96e;
                    position: absolute;
                    left: -27px;
                    top: 4px;
                  "
                ></i
                >{{ node.label }}
              </span>
            </span>
          </el-tree>
        </div>
        <p
          style="
            color: #ccc;
            height: 20px;
            margin-bottom: 0;
            position: absolute;
            bottom: 10px;
            left: 10px;
          "
        >
          {{ joinnumber }}
        </p>

        <el-button
          type="primary"
          plain
          style="position: absolute; bottom: 10px; right: 10px"
          @click="bjFun('d')"
          v-if="data.length != 0 && v"
          icon="el-icon-edit"
          size="mini"
          >笔记</el-button
        >
        <el-button
          type="primary"
          plain
          style="position: absolute; bottom: 10px; right: 10px"
          @click="bjFun('g')"
          v-if="data.length != 0 && !v"
          icon="el-icon-close"
          >笔记</el-button
        >
      </el-col>
      <el-col :span="rightSpan" style="padding-left: 0">
        <div class="right-top">
          <span>
            <el-tooltip
              class="item"
              effect="dark"
              :content="fold ? '展开电子书' : '收缩电子书'"
              placement="top"
            >
              <span
                style="
                  margin-right: 15px;
                  font-weight: bold;
                  font-size: 18px;
                  float: left;
                  margin-top: -3px;
                  font-size: 23px;
                  color: #fdffe5;
                  cursor: pointer;
                "
                @click="foldFun"
              >
                <i :class="fold ? 'el-icon-s-fold' : 'el-icon-s-unfold'"></i>
              </span>
            </el-tooltip>
            <span class="iphoneS">{{ name }}</span>
          </span>
          <span>{{ readB }}</span>
          <ul class="box_ul">
            <li
              @click="goFun(run_url)"
              :style="
                run_url == ''
                  ? 'color:rgb(193 193 193) !important'
                  : 'color:#fff'
              "
            >
              <!-- <el-tooltip
                class="item"
                effect="dark"
                content="运行"
                placement="bottom-start"
              > -->
              <svg
                t="1688002916133"
                v-if="run_url != ''"
                style="margin-right: 5px; margin-top: 4px; float: left"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="1524"
                width="16"
                height="16"
              >
                <path
                  d="M64 128v768h896V128H64zM0 64h1024v896H0V64z"
                  fill="#ffffff"
                  p-id="1525"
                ></path>
                <path
                  d="M64 256h896v64H64zM448 704H768V768H448zM290.2784 772.548267l162.269867-162.269867L290.2784 448l-45.2608 45.252267 117.0176 117.026133L245.0176 727.296z"
                  fill="#ffffff"
                  p-id="1526"
                ></path>
              </svg>
              <!-- </el-tooltip> -->
              <svg
                v-else
                style="margin-right: 5px; margin-top: 4px; float: left"
                t="1699493253244"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="4087"
                width="16"
                height="16"
              >
                <path
                  d="M917.333333 835.413333H106.666667V188.586667h810.666666zM186.666667 755.413333h650.666666V268.586667H186.666667z"
                  fill="#bfbfbf"
                  p-id="4088"
                ></path>
                <path
                  d="M343.04 648.746667l-56.533333-56.533334 88.32-88.32-88.32-88.32 56.533333-56.746666 144.853333 145.066666-144.853333 144.853334zM507.093333 585.173333h230.4v80h-230.4z"
                  fill="#bfbfbf"
                  p-id="4089"
                ></path>
              </svg>

              <!-- <svg
                t="1689654802722"
                v-else
                style="margin-right: 5px; margin-top: 4px; float: left"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="1802"
                width="16"
                height="16"
              >
                <path
                  d="M64 128v768h896V128H64zM0 64h1024v896H0V64z"
                  fill="#0873a4"
                  p-id="1803"
                ></path>
                <path
                  d="M64 256h896v64H64zM448 704H768V768H448zM290.2784 772.548267l162.269867-162.269867L290.2784 448l-45.2608 45.252267 117.0176 117.026133L245.0176 727.296z"
                  fill="#0873a4"
                  p-id="1804"
                ></path>
              </svg> -->
              云实验
            </li>
            <li
              @click="goFun(mooc_url)"
              :style="
                mooc_url == ''
                  ? 'color:rgb(193 193 193) !important'
                  : 'color:#fff'
              "
            >
              <!-- <el-tooltip
                class="item"
                effect="dark"
                content="观看课程视频"
                placement="bottom-start"
              > -->
              <i class="el-icon-view ii"></i>视频
              <!-- </el-tooltip> -->
            </li>

            <li
              @click="goFun(read_url)"
              :style="
                read_url == ''
                  ? 'color:rgb(193 193 193) !important'
                  : 'color:#fff'
              "
            >
              <!-- <el-tooltip
                class="item"
                effect="dark"
                content="在线阅读课件"
                placement="bottom-start"
              > -->
              <i class="el-icon-monitor ii"></i>课件
              <!-- </el-tooltip> -->
            </li>
            <!-- <li @click="goFun(download_url)">
         
               <i class="el-icon-download ii"></i>下载本章节课件
        
              
            </li> -->
            <li
              v-if="
                course_url != '' ||
                (course_url == '' && course_list.length == 0)
              "
              :style="
                course_url == ''
                  ? 'color:rgb(193 193 193) !important'
                  : 'color:#fff'
              "
              @click="goFun(course_url)"
            >
              <i class="el-icon-reading ii"></i>
              <span
                class="el-dropdown-link"
                :style="
                  course_url == ''
                    ? 'color:rgb(193 193 193) !important'
                    : 'color:#fff'
                "
              >
                作业
              </span>
            </li>

            <li v-else>
              <!-- <el-tooltip
                class="item"
                effect="dark"
                content="课程"
                placement="bottom-start"
              > -->
              <i
                class="el-icon-reading ii"
                style="float: left; margin-top: 2px"
              ></i>
              <el-dropdown @command="handleCommand">
                <span
                  class="el-dropdown-link"
                  :style="
                    course_list.length == 0
                      ? 'color:rgb(193 193 193) !important'
                      : 'color:#fff'
                  "
                >
                  作业<i class="el-icon-arrow-down el-icon--right"></i>
                </span>

                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :command="item.value"
                    v-for="(item, index) in course_list"
                    :key="index"
                    ><p>{{ item.title }}</p></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- </el-tooltip> -->
              <!-- <el-divider direction="vertical"></el-divider> -->
            </li>
            <li
              @click="goFun(github_url)"
              :style="
                github_url == ''
                  ? 'color:rgb(193 193 193) !important;line-height:24px;'
                  : 'color:#fff;line-height:24px;'
              "
            >
              <svg
                t="1690185771765"
                style="margin-right: 5px; margin-top: 4px; float: left"
                v-if="github_url != ''"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2280"
                width="16"
                height="16"
              >
                <path
                  d="M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9 23.5 23.2 38.1 55.4 38.1 91v112.5c0.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z"
                  p-id="2281"
                  fill="#ffffff"
                ></path>
              </svg>

              <svg
                t="1699493383368"
                style="margin-right: 5px; margin-top: 4px; float: left"
                v-else
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="5268"
                width="16"
                height="16"
              >
                <path
                  d="M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9 23.5 23.2 38.1 55.4 38.1 91v112.5c0.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z"
                  p-id="5269"
                  fill="#bfbfbf"
                ></path>
              </svg>
              GitHub
            </li>
            <li>
              <!-- <el-tooltip
                class="item"
                effect="dark"
                content="课程"
                placement="bottom-start"
              > -->

              <el-popover
                placement="top-start"
                title="分享"
                width="350"
                trigger="hover"
              >
                <div>
                  <!-- {{ FxUrl }} -->
                  <span style="font-weight: bold">【 方式一 】</span>
                  <el-button type="success" plain size="mini" @click="copy"
                    >复制链接</el-button
                  >
                </div>
                <el-divider></el-divider>
                <div class="flex-box">
                  <span style="font-weight: bold; float: left"
                    >【 方式二 】</span
                  >
                  <div
                    class="qr-code"
                    ref="qrCodeUrl"
                    style="display: inline-block"
                  ></div>
                </div>

                <el-button
                  type="primary"
                  slot="reference"
                  plain
                  class="el-icon-share ii"
                  >分享</el-button
                >
              </el-popover>

              <!-- </el-tooltip> -->
            </li>
          </ul>
        </div>
        <div style="" id="iframe">
          <!-- {{iframeSrc}} -->
          <iframe
            v-if="curiFrame"
            id="p"
            :src="iframeSrc"
            style="
              width: 100%;
              overflow: auto;
              height: calc(100vh - 58px);
              box-sizing: border-box;
            "
          ></iframe>
          <!-- <VueMarkdown
            v-else
            :source="iframeSrc"
            class="articalContent markdown-body"
            style="padding: 20px; text-align: left"
            :breaks="true"
            :typographer="true"
            :linkify="true"
            :highlight="false"
          ></VueMarkdown> -->

          <!-- <VueMarkdown
          :plugins="plugins"
            :source="textA"
            class="articalContent markdown-body"
            style="padding: 20px; text-align: left"
            :breaks="true"
            :typographer="true"
            :linkify="true"
            :highlight="false"
          ></VueMarkdown> -->
          <!-- <vue-markdown :source="markdown"   :plugins="plugins"></vue-markdown> -->
          <Viewer
            v-else
            :value="iframeSrc"
            :plugins="plugins"
            style="padding: 20px; text-align: left"
          />
        </div>
        <div
          style="margin-top: 30px; text-align: left; padding: 10px"
          v-if="data.length != 0"
        >
          <el-divider content-position="left">
            <h2 style="color: #0983b4">
              <i class="el-icon-edit"></i>发表、查看笔记
            </h2></el-divider
          >
          <div style="padding: 10px">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              v-model="textarea"
              maxlength="100"
              show-word-limit
            >
            </el-input>
            <el-button
              type="success"
              size="mini"
              style="margin-top: 10px"
              @click="bjFunList"
              >发表提交</el-button
            >
          </div>
          <ul class="ul-box">
            <li v-for="(item, index) in bjAry" :key="index">
              <h4>
                用户：{{ item.name }}
                <time style="color: #ccc; margin-left: 50px"
                  >{{ item._sys_creattime }}
                </time>
              </h4>
              <p
                style="
                  color: rgb(133 129 129);
                  font-size: 14px;
                  margin-top: 9px;
                "
              >
                {{ item.comment }}
              </p>
              <el-divider></el-divider>
            </li>
          </ul>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
  <script>
// import VueMarkdown from "vue-markdown";
import gfm from "@bytemd/plugin-gfm";
import math from "@bytemd/plugin-math";
// import pluginBreaks from '@bytemd/plugin-breaks'
// import pluginFrontmatter from '@bytemd/plugin-frontmatter'
import pluginGemoji  from '@bytemd/plugin-gemoji'
//  import pluginHighlight  from '@bytemd/plugin-highlight'
// import pluginHighlightSsr  from '@bytemd/plugin-highlight-ssr'
// import pluginMathSsr  from '@bytemd/plugin-math-ssr'
// import pluginMediumZoom  from '@bytemd/plugin-medium-zoom'
// import pluginMermaid  from '@bytemd/plugin-mermaid'

import { Editor, Viewer } from "@bytemd/vue";
// import MarkdownIt from "markdown-it";

import "bytemd/dist/index.min.css";
// import 'katex/dist/katex.css'
// import markdownItEmoji from 'markdown-it-emoji';
// import markdownItKatex from 'markdown-it-katex';

import QRCode from "qrcodejs2";
const plugins = [
  gfm(),
  math(),
  // pluginBreaks(),
  // pluginFrontmatter(),
  pluginGemoji(),
  // pluginHighlight(),
  // pluginHighlightSsr(),
  // pluginMathSsr(),
  // pluginMediumZoom(),
  // pluginMermaid()
  // Add more plugins here
];
export default {
  data() {
    return {
      props: {
        label: "label",
        children: "children",
        isLeaf: "next",
      },

      FxUrl: window.location.href,
      time: 0,
      degin: "",
      end: "",
      v: true,
      textarea: "",
      data: [],
      id: "",
      name: "",
      defaultProps: {
        children: "children",
        label: "label",
      },
      bsLogin: false,
      bjAry: [
        // {name:'安静111',dec:'这本书藏着浩瀚的知识',time:'2023-03-01'},
        // {name:'zhouqi',dec:'内容生动性：图画很逼真,动态展示',time:'2023-03-05'},
        // {name:'安东尼',dec:'正如莫扎特所说：我每天花12小时练琴，人们却用“天才”两个字掩盖了我所有的努力。“天才”给无数日日夜夜坚持和努力得到的结果，加上了一层光芒四射的滤镜，变得让普通人可望而不可即',time:'2023-01-05'},
      ],
      iframeSrc: "",
      // markdown: '# Hello, \r\n\r\nVue Markdown! \sin{\theta}',
      value:
        "# 进制\r\n\r\n下面来简单介绍一下数学上进制的概念。\r\n\r\n进位制（positional notation 或 place-value notation），是一种编码数的方式。	\\uparrow这里我们不形式化地介绍这个概念，只描述一个在应用层面较为准确的概念。在下面的说明中，默认十进制表示是个先验概念，如无特殊记号指明，所有数均为十进制表示。同时我们约定：在下面的说明中，位都是从 0 开始编号的。不难修改相关定义使得位从 1 开始编号。\r\n\r\n一个 $n$ 位 $b$ 进制数（base-b number）为一个字符串 $(b_{n - 1}b_{n - 2}\\dots b_1 b_0)_{(b)}$，其中 $b_i \\in \\{0, 1, \\dots, b - 1\\}$。定义其表示的值为\r\n\r\n$$\r\n(b_{n - 1}b_{n - 2}\\dots b_1 b_0)_b = \\sum\\limits_{i = 0}^{n - 1} b_i \\times b^i\r\n$$\r\n\r\n其中 $b_i$ 称为第 $i$ 位的位权。当不特殊指明位数时，代表在当前上下文中，位数不重要。$b$ 进制数也称作基数（base）为 $b$ 的数。\r\n\r\n比如 $\\rm{10B}_{(16)}=1\\times 16^2+0\\times 16^1+11\\times 16^0=267$，给出了 $267$ 在十六进制下的表示。在十以上进制中，为了不造成解读上的困难，通常使用英文字母来表示 $10$ 及其以上的数。比如十六进制中的 $\\mathrm{A,B,C,D,E,F}$ 分别代表十进制的 $10,11,12,13,14,15$。字母的大小写一般不重要。\r\n\r\n由于十六进制的广泛使用，人们规定了一种十六进制数的表示，即在数前加 `0x` 以区分十进制数。比如 $(5\\mathrm{a})_{(16)}$ 可以写作 `0x5a`。",
      plugins,
      markdown:
        "# 进制\r\n\r\n下面来简单介绍一下数学上进制的概念。\r\n\r\n进位制（positional notation 或 place-value notation），是一种编码数的方式。	\\uparrow这里我们不形式化地介绍这个概念，只描述一个在应用层面较为准确的概念。在下面的说明中，默认十进制表示是个先验概念，如无特殊记号指明，所有数均为十进制表示。同时我们约定：在下面的说明中，位都是从 0 开始编号的。不难修改相关定义使得位从 1 开始编号。\r\n\r\n一个 $n$ 位 $b$ 进制数（base-b number）为一个字符串 $(b_{n - 1}b_{n - 2}\\dots b_1 b_0)_{(b)}$，其中 $b_i \\in \\{0, 1, \\dots, b - 1\\}$。定义其表示的值为\r\n\r\n$$\r\n(b_{n - 1}b_{n - 2}\\dots b_1 b_0)_b = \\sum\\limits_{i = 0}^{n - 1} b_i \\times b^i\r\n$$\r\n\r\n其中 $b_i$ 称为第 $i$ 位的位权。当不特殊指明位数时，代表在当前上下文中，位数不重要。$b$ 进制数也称作基数（base）为 $b$ 的数。\r\n\r\n比如 $\\rm{10B}_{(16)}=1\\times 16^2+0\\times 16^1+11\\times 16^0=267$，给出了 $267$ 在十六进制下的表示。在十以上进制中，为了不造成解读上的困难，通常使用英文字母来表示 $10$ 及其以上的数。比如十六进制中的 $\\mathrm{A,B,C,D,E,F}$ 分别代表十进制的 $10,11,12,13,14,15$。字母的大小写一般不重要。\r\n\r\n由于十六进制的广泛使用，人们规定了一种十六进制数的表示，即在数前加 `0x` 以区分十进制数。比如 $(5\\mathrm{a})_{(16)}$ 可以写作 `0x5a`。",
      curiFrame: true, // 非富文本
      mooc_url: "",
      read_url: "",
      download_url: "",
      run_url: "",
      course_url: "",
      course_list: [],
      github_url: "",
      zjId: "",
      type: "/index.do",
      timer: null,
      readB: "",
      newId: false,
      fold: true,
      foldM: false,
      iconF: "",
      rightSpan: 20,
      lefeSpan: 4,
      joinnumber: "0人参加",
      htmlContent: "",
      courseId: "",
    };
  },
  components: { Editor, Viewer },
  mounted() {
    //     var md = require('markdown-it')(),
    //     mk = require('markdown-it-katex');

    // md.use(mk);
    // //" # 原码\r\n\r\n由于计算机采用开关元件，现代计算机均使用二进制位的序列（bit sequence）来表示数，包括小数。实际上，历史上前苏联曾经尝试开发过三进制计算机，想深入了解的可以自行搜索。\r\n\r\n在数学上表示整数时，我们使用前缀负号（-）来表示负数。那么用二进制表示整数的最直观的想法，就是将其绝对值直接转为二进制，再用最高位表示正负号。这种表示方法被称作原码。举例来说，如果将 $1$ 和 $-1$ 表示为 $3$ 位原码，则结果分别是 `001` 和 `101`。显然 $n$ 位的原码系统可以表示 $[-2^{n - 1} + 1, 2^{n - 1} - 1]$ 内的整数。\r\n\r\n注意到，上述表示中，$0$ 有两种表示方法（正 $0$ 和负 $0$），这是原码带来的不便之一。其次，如果要做运算的话，原码不能直接相加，需要根据符号位做相应判断：同号绝对值相加，异号绝对值大的减去绝对值小的，最后置符号位。因此，在现代计算机中涉及整数的计算，一般不使用原码。\r\n\r\n根据 [Wikipedia 上的资料](https://en.wikipedia.org/wiki/Signed_number_representations#Sign-and-magnitude_method)，由于原码十分直观，因此在早期的计算机中得以使用。除此以外，原码在数制中的另一大用处即为表示浮点数的有效数字，也是当今几乎所有计算机表示浮点数的标准。其具体考量留待补码时做进一步说明。\r\n"

    // // double backslash is required for javascript strings, but not html input
    // this.markdown = md.render('# Math Rulez! \n  $\\sqrt{3x-1}+(1+x)^2$   $(b_{n - 1}b_{n - 2}\\dots b_1 b_0)_{(b)}$');
    this.id = this.$route.query.id;
    console.log(this.id);
    this.courseId = this.$route.query.id;

    this.name = this.$route.query.name;
    this.type = this.$route.query.type;
    this.begin = this.currentTime();
    // let timer=setInterval(()=>{
    //   this.time ++;
    // },1000)
    this.setTimeFun();
    // this.seachFun();

    this.creatQrCode(); // 创建二维码
  },

  beforeDestroy() {
    console.log("清理定时器");
    if (this.timer) {
      //如果定时器还在运行 或者直接关闭，不用判断
      clearInterval(this.timer); //关闭
    }
  },

  // beforeRouteLeave:(to, from, next) => {
  beforeRouteLeave: function (to, from, next) {
    clearInterval(this.timer);
    next();
  },
  methods: {
    handleChange(v) {
      this.value = v;
    },
    handleCommand(command) {
      if (
        window.localStorage.getItem("anjing_name_ebook") &&
        window.localStorage.getItem("anjing_name_ebook") != "" &&
        !this.bsLogin
      ) {
        window.open(command);
      } else {
        this.$confirm("登录后可继续阅读, 是否登录?", "登录提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.loginFun();
          })
          .catch(() => {});
      }
    },

    tokenFun() {
      let data = {
        op: "getuserinfo",
        token: window.localStorage.getItem("anjing_name_token"),
      };
      let _this = this;
      this.$ajax
        .post(this.url + "/index.do", _this.Qs.stringify(data))
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
            // _this.role = response.data.data.role;
            // // window.location.href = response.data.data;
            // _this.name = response.data.data.name;
            // _this.uid = response.data.data.uid;
            // window.localStorage.setItem("anjing_name_uid", _this.uid);
            // window.localStorage.setItem("anjing_name_role", _this.role);
            window.localStorage.setItem(
              "anjing_name_ebook",
              response.data.data.name
              // this.getQueryString("token")
            );
            // _this.name = window.localStorage.getItem("anjing_name_ebook");
            // _this.login = true;
            window.localStorage.setItem(
              "anjing_name_username",
              response.data.data.username
              // this.getQueryString("token")
            );

            // _this.init();
          } else if (response.data.value == "失效") {
            _this.$message.info("登录已失效，请重新登录！");

            window.localStorage.setItem("anjing_name_ebook", "");
            window.localStorage.setItem("anjing_name_token", "");
            window.localStorage.setItem("anjing_name_uid", "");
            window.localStorage.setItem("anjing_name_role", "");
            window.localStorage.setItem("anjing_name_username", "");
          } else {
            window.localStorage.setItem("anjing_name_ebook", "");
            window.localStorage.setItem("anjing_name_token", "");
            window.localStorage.setItem("anjing_name_uid", "");
            window.localStorage.setItem("anjing_name_role", "");
            window.localStorage.setItem("anjing_name_username", "");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async loadNode(node, resolve) {
      debugger;
      if (window.location.href.indexOf("token=") != -1) {
        window.localStorage.setItem(
          "anjing_name_token",

          this.$route.query.token
        );
        this.tokenFun();
      }
      debugger;
      console.log("777777777");
      console.log(node);
      if (node.level === 0) {
        // 加载第一级节点（年份）
        console.log("00000");
        console.log(this.data);
        setTimeout(() => {
          this.seachFun(resolve, node);
        }, 100);
      }
      if (node.level > 0) {
        // 加载第二级节点（月份）
        // return resolve(await this.initZ('64b7a62199e2a246b755f721'));
        console.log("898989898989898");

        if (
          window.localStorage.getItem("anjing_name_ebook") &&
          window.localStorage.getItem("anjing_name_ebook") != ""
        ) {
          this.initZ(resolve, node.data._id);
        } else {
          this.$confirm("登录后可继续阅读, 是否登录?", "登录提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.loginFun();
            })
            .catch(() => {});
        }
      }
      return resolve([]);
    },
    getQueryString(name) {
      debugger;
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    },
    /* 创建二维码 */
    creatQrCode() {
      let URL = window.location.href;
      if (URL.indexOf("token=") != -1) {
        // 存在
        URL = URL.split("&token=")[0];
      }
      new QRCode(this.$refs.qrCodeUrl, {
        text: URL, // 二维码的内容
        width: 100,
        height: 100,
        colorDark: "#000",
        colorLight: "#fff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    seachFun(resolve) {
      let data = {
        op: "getbookinfo",
        seqid: this.id,
      };
      let _this = this;
      this.$ajax
        .post(this.url + "/index.do", _this.Qs.stringify(data))
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
            _this.id = response.data.data.id;
            _this.type = response.data.data.type;
            _this.name = response.data.data.name;
            _this.joinnumber = response.data.data.joinnumber;
            // _this.readB = response.data.data;
            if (_this.type == "hz") {
              _this.init("/company.do", resolve);
            } else {
              _this.init("/index.do", resolve);
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    currentTime() {
      var date = new Date();
      var year = date.getFullYear(); //月份从0~11，所以加一
      let month = date.getMonth();
      console.log("month", month);
      var dateArr = [
        date.getMonth() + 1,
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
      ];
      //如果格式是MM则需要此步骤，如果是M格式则此循环注释掉
      for (var i = 0; i < dateArr.length; i++) {
        if (dateArr[i] >= 1 && dateArr[i] <= 9) {
          dateArr[i] = "0" + dateArr[i];
        }
      }
      var strDate =
        year +
        "/" +
        dateArr[0] +
        "/" +
        dateArr[1] +
        " " +
        dateArr[2] +
        ":" +
        dateArr[3] +
        ":" +
        dateArr[4];
      //此处可以拿外部的变量接收  strDate:2022-05-01 13:25:30
      //this.date = strDate;
      console.log("strDate", strDate);
      return strDate;
    },
    copy() {
      let URL = window.location.href;
      if (URL.indexOf("token=") != -1) {
        // 存在
        URL = URL.split("&token=")[0];
      }
      navigator.clipboard.writeText(URL);

      console.log("复制的文本为: " + URL);
      this.$message.success("分享链接已复制成功！");
    },

    backIndex() {
      this.$router.push({ path: "./" });
    },
    foldFuM() {
      this.foldM = !this.foldM;

      if (this.foldM) {
        this.rightSpan = 14;
        this.lefeSpan = 10;
      } else {
        this.rightSpan = 20;
        this.lefeSpan = 4;
      }
    },
    // 收缩
    foldFun() {
      this.fold = !this.fold;

      if (this.fold) {
        this.rightSpan = 20;
        this.lefeSpan = 4;
        this.foldM = false;
      } else {
        this.rightSpan = 24;
        this.lefeSpan = 0;
        this.foldM = true;
      }
    },
    goFun(url) {
      console.log(url);
      if (
        window.localStorage.getItem("anjing_name_ebook") &&
        window.localStorage.getItem("anjing_name_ebook") != "" &&
        !this.bsLogin
      ) {
        //已登录并且没失效
        if (url == "") {
          this.$message.info("暂无信息");
          return;
        }

        window.open(url);
      } else {
        this.$confirm("登录后可继续阅读, 是否登录?", "登录提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.loginFun();
          })
          .catch(() => {});
      }
    },
    loginFun() {
      debugger;
      let data = {
        op: "login",
        type: "course",
        key: "id",
        value: this.courseId,
        // course:this.courseId
      };
      let _this = this;
      this.$ajax
        .post(this.url + "/index.do", _this.Qs.stringify(data))
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
            window.location.href = response.data.data;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    init(type, resolve) {
      console.log(222);
      debugger;
      console.log(1);
      let data = {
        op: "catalog",
        _id: this.id,
        token: window.localStorage.getItem("anjing_name_token"),
      };
      let _this = this;
      this.$ajax
        .post(this.url + type, _this.Qs.stringify(data))
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
            debugger;

            _this.data = response.data.data;
            _this.mooc_url = response.data.data[0].mooc_url;
            _this.read_url = response.data.data[0].read_url;
            _this.download_url = response.data.data[0].download_url;
            _this.run_url = response.data.data[0].run_url;
            _this.course_url = response.data.data[0].course_url;
            _this.course_list = response.data.data[0].course_list;
            // _this.list = response.data.data[0].list;
            _this.github_url = response.data.data[0].github_url;
            _this.zjId = response.data.data[0]._id;

            _this.bjList();
            _this.begin = _this.currentTime();
            if (_this.data.length > 0) {
              _this.timer = setInterval(() => {
                _this.end = _this.currentTime();
                _this.readlogFun();
              }, 60000);
            }

            console.log(response.data.data[0]);
            if (response.data.data[0].type == "HTML") {
              _this.iframeSrc = response.data.data[0].html_url;
              _this.curiFrame = true;
            } else if (response.data.data[0].type == "Markdown") {
              console.log(response.data.data[0].MDbody);
              _this.iframeSrc =
                "$$(b_{n - 1}b_{n - 2}dots b_1 b_0)_b = sumlimits_{i = 0}^{n - 1} b_i \times b^i$$其中 $b_i$ 称为第 $i$ 位的位权。"; // response.data.data[0].MDbody;
              console.log(22);
              _this.curiFrame = false;
            } else if (response.data.data[0].type == "PDF") {
              _this.iframeSrc =
                "pdfjs/web/viewer.html?file=" + response.data.data[0].pdf_url;
              _this.curiFrame = true;
            } else {
              _this.iframeSrc = response.data.data[0].body;
              _this.curiFrame = false;
            }
            if (!response.data.online) {
              _this.bsLogin = true; // 说明登录异常
            }
            console.log("8888888888888");
            console.log(response.data.data);
            return resolve(response.data.data);
            //
          }

          // else if (response.data.value == "sessionerror") {
          //   _this.$message.info(response.data.msg);

          //   setTimeout(() => {
          //     _this.$router.push({ path: "./", query: { type: "out" } });
          //   }, 2000);
          // }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    initZ(resolve, pid) {
      console.log(pid);
      let curType = "";
      if (this.type == "hz") {
        curType = "/company.do";
      } else {
        curType = "/index.do";
      }
      debugger;
      console.log(1);
      let data = {
        op: "catalog",
        _id: this.id,
        pid: pid,
        token: window.localStorage.getItem("anjing_name_token"),
      };
      let _this = this;
      this.$ajax
        .post(this.url + curType, _this.Qs.stringify(data))
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
            debugger;

            // _this.data = response.data.data;
            // _this.mooc_url = response.data.data[0].mooc_url;
            // _this.read_url = response.data.data[0].read_url;
            // _this.download_url = response.data.data[0].download_url;
            // _this.run_url = response.data.data[0].run_url;
            // _this.course_url = response.data.data[0].course_url;
            // _this.github_url = response.data.data[0].github_url;
            // _this.zjId = response.data.data[0]._id;

            // // _this.bjList();
            // _this.begin = _this.currentTime();
            // if (_this.data.length > 0) {
            //   _this.timer = setInterval(() => {
            //     _this.end = _this.currentTime();
            //     _this.readlogFun();
            //   }, 60000);
            // }

            // console.log(response.data.data[0]);
            // if (response.data.data[0].type == "HTML") {
            //   _this.iframeSrc = response.data.data[0].html_url;
            //   _this.curiFrame = true;
            // } else if (response.data.data[0].type == "Markdown") {
            //   console.log(response.data.data[0].MDbody);
            //   _this.iframeSrc = response.data.data[0].MDbody;
            //   console.log(22);
            //   _this.curiFrame = false;
            // } else if (response.data.data[0].type == "PDF") {
            //   _this.iframeSrc =
            //     "pdfjs/web/viewer.html?file=" + response.data.data[0].pdf_url;
            //   _this.curiFrame = true;
            // } else {
            //   _this.iframeSrc = response.data.data[0].body;
            //   _this.curiFrame = false;
            // }
            // if (!response.data.online) {
            //   _this.bsLogin = true; // 说明登录异常
            // }
            // console.log("8888888888888");
            // console.log(response.data.data);
            return resolve(response.data.data);
            //
          }

          // else if (response.data.value == "sessionerror") {
          //   _this.$message.info(response.data.msg);

          //   setTimeout(() => {
          //     _this.$router.push({ path: "./", query: { type: "out" } });
          //   }, 2000);
          // }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    readpercentFun() {
      // _this.readB = ''
      let data = {
        op: "readpercent",
        cid: this.zjId,
        uid: window.localStorage.getItem("anjing_name_uid"),
      };
      let _this = this;
      this.$ajax
        .post(this.url + "/index.do", _this.Qs.stringify(data))
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
            _this.readB = response.data.data;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    bjList() {
      let data = {
        op: "noteslist",
        _id: this.zjId,
      };
      let _this = this;
      this.$ajax
        .post(this.url + "/index.do", _this.Qs.stringify(data))
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
            _this.bjAry = response.data.data;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    bjFunList() {
      if (
        window.localStorage.getItem("anjing_name_ebook") &&
        window.localStorage.getItem("anjing_name_ebook") != ""
      ) {
        let data = {
          op: "addnote",
          _id: this.zjId,
          uid: window.localStorage.getItem("anjing_name_uid"),
          username: window.localStorage.getItem("anjing_name_username"),
          comment: this.textarea,
        };
        let _this = this;
        this.$ajax
          .post(this.url + "/index.do", _this.Qs.stringify(data))
          .then(function (response) {
            console.log(response);
            if (response.data.value == "ok") {
              _this.bjList();
              _this.textarea = "";
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        this.$confirm("登录后可提交笔记, 是否登录?", "登录提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.loginFun();
          })
          .catch(() => {});
      }
    },

    readlogFun() {
      let percent = 1;
      if (
        window.localStorage.getItem("pdf-anjing-page") &&
        window.localStorage.getItem("pdf-anjing-num")
      ) {
        percent =
          window.localStorage.getItem("pdf-anjing-page") /
          window.localStorage.getItem("pdf-anjing-num");
      }
      this.time =
        (new Date(this.end).getTime() - new Date(this.begin).getTime()) / 1000;
      let data = {
        op: "readlog",
        _id: this.zjId,
        begin: this.begin,
        end: this.end,
        time: this.time,
        percent: percent,
        uid: window.localStorage.getItem("anjing_name_uid"),
      };
      let _this = this;
      this.$ajax
        .post(this.url + "/index.do", _this.Qs.stringify(data))
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
            debugger;
            _this.readpercentFun();

            for (let i = 0; i < _this.data.length; i++) {
              if (_this.data[i]._id == _this.zjId) {
                // 就找到这个章节了打钩
                debugger;
                _this.data[i].read = true;
                _this.data[i].icon = "el-icon-check";
              }
            }
            for (let i = 0; i < _this.data.length; i++) {
              for (let y = 0; y < _this.data[i].children.length; y++) {
                if (_this.data[i].children[y]._id == _this.zjId) {
                  // 就找到这个章节了打钩

                  _this.data[i].children[y].read = true;
                  _this.data[i].children[y].icon = "el-icon-check";
                }
              }
            }
            console.log(_this.data);

            // _this.init()
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    bjFun(v) {
      if (v == "d") {
        let h = document.getElementById("iframe").offsetHeight;
        document.documentElement.scrollTop = h + 100;
        this.v = false;
        this.bjList();
      } else {
        document.documentElement.scrollTop = 0;
        // document.getElementById('#viewerContainer').scrollTop=0

        this.v = true;
      }
    },
    handleNodeClick(data, node) {
      debugger;
      if (
        window.localStorage.getItem("anjing_name_ebook") &&
        window.localStorage.getItem("anjing_name_ebook") != ""
      ) {
        //已登录

        document.documentElement.scrollTop = 0;

        this.v = true;
        this.begin = this.currentTime();
        this.mooc_url = data.mooc_url;
        this.read_url = data.read_url;
        this.download_url = data.download_url;
        this.run_url = data.run_url;
        this.course_url = data.course_url;
        this.course_list = data.course_list;
        this.github_url = data.github_url;
        this.zjId = data._id;
        console.log(this.github_url);
        if (data.type == "HTML") {
          this.iframeSrc = data.html_url;
          this.curiFrame = true;
        } else if (data.type == "Markdown") {
          this.iframeSrc = data.MDbody;
          console.log(2);
          this.curiFrame = false;
        } else if (data.type == "PDF") {
          this.iframeSrc = "pdfjs/web/viewer.html?file=" + data.pdf_url;
          this.curiFrame = true;
          debugger;

          this.readlogFun();

          this.setTimeFun();
        } else {
          this.curiFrame = false;
          this.iframeSrc = data.body;
        }
      } else {
        this.$confirm("登录后可继续阅读, 是否登录?", "登录提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.loginFun();
          })
          .catch(() => {});
      }
    },
    // loginFun() {
    //   debugger;
    //   let data = {
    //     op: "login",
    //   };
    //   let _this = this;
    //   this.$ajax
    //     .post(this.url + "/index.do", _this.Qs.stringify(data))
    //     .then(function (response) {
    //       console.log(response);
    //       if (response.data.value == "ok") {
    //         window.location.href = response.data.data;
    //       }
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //     });
    // },
    setTimeFun() {
      setTimeout(() => {
        if (
          document
            .getElementById("p")
            .contentWindow.document.getElementById("viewer").textContent != ""
        ) {
          document
            .getElementById("p")
            .contentWindow.document.getElementById(
              "viewerContainer"
            ).scrollTop = 0;
        } else {
          this.setTimeFun();
        }
        console.log(8);
      }, 1000);
    },
  },
};
</script>
  <style>
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.box_ul ul,
.box_ul li {
  margin: 0;
  padding: 0;
  list-style: none;
}
.el-tree-node__label {
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
}
.el-tree-node__content {
  display: block;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 5px 0;
}

.el-tree-node {
  border-bottom: 1px solid #f5f5f5;
  line-height: 28px;
}
.el-tree-node__content:hover,
.el-upload-list__item:hover {
  background-color: #d2e1f8;
}
</style>
  <style  scoped>
h2,
h3,
h4 {
  padding: 0;
  margin: 0;
}

.ul-box .el-divider--horizontal {
  margin: 10px 0;
}
.ul-box {
  margin-top: 10px;
  padding: 10px;
}
.ul-box li {
  list-style: none;
}
.left {
  text-align: left;
  /* padding:0 10px 0; */
  border-bottom: 1px solid #ccc;
  position: relative;
  height: 40px;
}
.right-top {
  background: rgb(6 109 192);
  color: #fff;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  padding: 8px;
  position: sticky;
  top: 0;
}
.box_ul {
  overflow: hidden;
}
.box_ul li {
  float: left;
  margin-right: 15px !important;
  padding: 0 !important;
  color: #fff !important;
  /* font-size: 18px!important; */
  cursor: pointer;
}
.ii {
  padding: 2px 5px !important;
  cursor: pointer;
}
.el-col-20 {
  padding-right: 0 !important;
}
.el-row {
  margin: 0 !important;
}
@media (max-width: 880px) {
  .iphoneS {
    display: none;
  }
  .phone {
    display: block;
  }
}

:deep(.katex-html) {
  display: none;
}
</style>

  